import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from "@mui/icons-material/Download";
import { DeleteButton } from "./Button";
import { submitSiteDelete } from "../delete";
import moment from "moment";
import { getPermissions } from "../../../Components/rbac/hasAccess";
import FlagIcon from "@mui/icons-material/Flag";
import InfoIcon from "@mui/icons-material/Info";
import { Tooltip } from "@mui/material";
import PartiallyDisbursedHistory from "../../../Components/requirement/partiallyDisbursedHistory";
import { useLocation } from "react-router-dom";

const ListView = ({
  headers,
  data,
  actions = {},
  rowsPerPageOptions = [30, 50, 100],
  showCheckbox = false,
  deleteTableName = "",
  setSelectedOuterID = () => {},
  moduleId = 0,
  headerEmployee = false,
  headerEmployeeKeys,
  _employeeId,
  // 👇 Pagination props from parent
  currentPage = 0,
  rowsPerPage = 30,
  totalRows = 0,
  onPaginationChange = () => {},
  requirement = false,
  reqList=false
}) => {

  const location = useLocation();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);


  // Permissions from moduleId
  const permissions = getPermissions(moduleId);
  const canPerformActions =
    permissions.allAccess ||
    permissions.edit ||
    permissions.delete ||
    permissions.copy ||
    permissions.approve ||
    permissions.view ||
    permissions.pdfDownload;

  //  Use full data directly (no slicing)
  const paginatedData = data;

  const totalPages = Math.ceil(totalRows / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      onPaginationChange(newPage, rowsPerPage);

      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    const newRows = parseInt(e.target.value, 10);
    onPaginationChange(0, newRows); // Reset to first page
    
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handleSelectRow = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter((item) => item !== id)
      : [...selectedIds, id];
    setSelectedIds(updated);
    setSelectedOuterID(updated);
  };

  const handleSelectAll = () => {
    if (selectedIds.length === paginatedData.length) {
      setSelectedIds([]);
      setSelectedOuterID([]);
    } else {
      const allIds = paginatedData.map((row) => row.id);
      setSelectedIds(allIds);
      setSelectedOuterID(allIds);
    }
  };

  const isAllSelected =
    selectedIds.length === paginatedData.length && paginatedData.length > 0;

  const handleMultipleDelete = () => {
    submitSiteDelete(deleteTableName, selectedIds);
  };

  return (
    <>
      {selectedIds.length > 0 &&
        deleteTableName &&
        (permissions.delete || permissions.allAccess) && (
          <div className="shadow-sm p-2 pt-1 mb-2 bg-white">
            <DeleteButton
              id="btn-multi-delete"
              label="Multiple Delete"
              onClick={handleMultipleDelete}
            />
          </div>
        )}

      <div className="w-full border rounded-md shadow">
        {/* Table Container */}
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                {showCheckbox && (
                  <th className="px-2 py-3 text-center">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  </th>
                )}
                {headers.map((header, i) => (
                  <th
                    key={i}
                    className="px-4 py-3 text-center whitespace-nowrap capitalize"
                  >
                    {header === "checkinPhotoPath"
                      ? "Punch In Photo"
                      : header === "checkoutPhoto"
                        ? "Punch Out Photo"
                        : header === "id"
                          ? "Sr. No."
                          : header
                              .replace(/([A-Z])/g, " $1")
                              .replace(/^./, (s) => s.toUpperCase())}
                  </th>
                ))}
                {canPerformActions && Object.keys(actions).length > 0 && (
                  <th className="px-4 py-3 text-center">Actions</th>
                )}
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {paginatedData.map((row, rowIndex) => {
                return (
                  <tr key={rowIndex} className="hover:bg-gray-50"
                  //  style={{
                  //       backgroundColor: reqList
                  //         ? row?.approveStatus === "Approved"
                  //           ? "rgb(180, 180, 235)"
                  //           : row?.approveStatus === "Rejected"
                  //             ? "rgb(245, 150, 143)"
                  //             : ""
                  //         : "",
                  //     }}
                  >
                    {showCheckbox && (
                      <td className="px-2 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={selectedIds.includes(row.id)}
                          onChange={() => handleSelectRow(row.id)}
                        />
                      </td>
                    )}

                    {headers.map((header, colIndex) => {
                      let cellValue = row[header];
                      const isoDateRegex = /^\d{4}-\d{2}-\d{2}(T.*Z)?$/;

                      if (
                        ["checkoutDatetime", "checkinDatetime"].includes(header)
                      ) {
                        const d = new Date(cellValue);
                        if (!cellValue) {
                          cellValue = "";
                        } else {
                          const day = String(d.getDate()).padStart(2, "0");
                          const month = String(d.getMonth() + 1).padStart(
                            2,
                            "0",
                          );
                          const year = d.getFullYear();
                          let h = d.getHours();
                          const m = String(d.getMinutes()).padStart(2, "0");
                          const ampm = h >= 12 ? "PM" : "AM";
                          h = h % 12 || 12;
                          cellValue = `${day}-${month}-${year} ${h}:${m} ${ampm}`;
                        }
                      }

                      if (
                        typeof cellValue === "string" &&
                        isoDateRegex.test(cellValue)
                      ) {
                        if (cellValue && cellValue !== "0000-00-00") {
                          cellValue = moment(cellValue).format("DD-MM-YYYY");
                        } else {
                          cellValue = "";
                        }
                      }

                      const approveBgClass = [
                        "approveManagerStatus",
                        "leaveStatus",
                        "approveLevel1",
                        "approveLevel2",
                        "l1StatusLabel",
                        "hodStatusLabel",
                        "h1StatusLabel",
                        "h2StatusLabel",
                        "approveStatus",
                        "finalLeaveStatus",
                        "approveLevel2Status",
                        "approveLevel1Status",
                        "l1ApproveStatus",
                        "hodApproveStatus",
                        "h1ApproveStatus",
                        "h2ApproveStatus",
                        "finalApproveStatus",
                      ].includes(header)
                        ? row[header] === "Pending"
                          ? "text-gray-600 font-semibold"
                          : row[header] === "Approved"
                            ? "text-green-600 font-semibold"
                            : row[header] === "Rejected"
                              ? "text-red-600 font-semibold"
                              : ""
                        : "";

                      return (
                        <td
                          key={colIndex}
                          className={`px-4 py-3 text-center ${approveBgClass}`}
                        >
                          {header === "assignInspector" && cellValue ? (
                            <div
                              dangerouslySetInnerHTML={{ __html: cellValue }}
                            />
                          ) : header === "id" ? (
                            <div className="flex items-center justify-center gap-1">
                              <span>
                                {currentPage * rowsPerPage + rowIndex + 1}
                              </span>

                              {row?.redFlagStatus == 1 && (
                                <FlagIcon
                                  fontSize="small"
                                  className="text-red-600"
                                  titleAccess="Red Flag"
                                />
                              )}
                            </div>
                          ) : header === "checkinPhotoPath" ||
                            header === "checkoutPhoto" ? (
                            cellValue ? (
                              <a
                                href={cellValue}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={cellValue}
                                  alt="preview"
                                  className="w-10 h-10 rounded-full object-cover border cursor-pointer"
                                />
                              </a>
                            ) : (
                              "-"
                            )
                          ) : (
                            cellValue
                          )}
                        </td>
                      );
                    })}

                    {canPerformActions && Object.keys(actions).length > 0 && (
                      <td className="px-4 py-2 text-center whitespace-nowrap">
                        <div className="flex items-center justify-center gap-2">
                          {actions.edit &&
                            (permissions.edit || permissions.allAccess) && (
                              <button
                                onClick={() => actions.edit(row)}
                                className="text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
                                disabled={
                                  row.leaveStatus === "Approved" ||
                                  row.leaveStatus === "Rejected"
                                }
                              >
                                <EditIcon fontSize="small" />
                              </button>
                            )}

                          {actions.view1 &&
                            (permissions.view || permissions.allAccess) && (
                              <button
                                onClick={() => actions.view1(row)}
                                className="text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
                              >
                                <VisibilityIcon fontSize="small" />
                              </button>
                            )}

                          {actions.print &&
                            (permissions.print || permissions.allAccess) && (
                              <button
                                onClick={() => actions.print(row)}
                                className="text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
                                // disabled={row.leaveStatus === "Approved" || row.leaveStatus === "Rejected"}
                              >
                                <PrintIcon fontSize="small" />
                              </button>
                            )}

                          {row?.redFlagStatus == 1 && (
                            <Tooltip
                              title={
                                row?.redFlagDetails ||
                                "Red flag details not available"
                              }
                              arrow
                              placement="top"
                            >
                              <IconButton
                                size="small"
                                // onClick={() => actions.info?.(row)}
                                className="text-red-600 hover:text-red-700"
                              >
                                <InfoIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}

                          {actions.delete &&
                            (permissions.delete || permissions.allAccess) && (
                              <button
                                onClick={() => actions.delete(row)}
                                disabled={
                                  row.leaveStatus === "Approved" ||
                                  row.leaveStatus === "Rejected"
                                }
                                className="text-blue-600 hover:text-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
                              >
                                <DeleteIcon fontSize="small" />
                              </button>
                            )}

                          {(() => {
                            const approvalMap = [
                              {
                                idKey: "appprovalManagerId",
                                rowKey: "approveManagerStatus",
                              },
                              {
                                idKey: "approvalLevel1Id",
                                rowKey: "approveLevel1",
                              },
                              {
                                idKey: "approvalLevel2Id",
                                rowKey: "approveLevel2",
                              },
                            ];

                            // Find which approval level the logged-in employee is
                            const matched = approvalMap.find(
                              (m) => row[m.idKey] == _employeeId,
                            );
                            const status = matched ? row[matched.rowKey] : null;

                            const reqDisableApprove =
                              row?.h2Status === 1 ||
                              row?.redFlagStatus == 1 ||
                              // if rejected anywhere
                              [
                                row?.l1Status,
                                row?.hodStatus,
                                row?.h1Status,
                                row?.h2Status,
                              ].includes(2) ||
                              // L1 rules → blocked if higher authority already acted
                              (permissions.l1 &&
                                (row?.l1Status !== 0 ||
                                  row?.hodStatus !== 0 ||
                                  row?.h1Status !== 0 ||
                                  row?.h2Status !== 0)) ||
                              // HOD rules → requires L1 approved and no higher authority acted
                              (permissions.hod &&
                                (row?.hodStatus !== 0 ||
                                  row?.l1Status !== 1 ||
                                  row?.h1Status !== 0 ||
                                  row?.h2Status !== 0)) ||
                              // H1 rules → blocked only if H2 already acted
                              (permissions.h1 &&
                                (row?.h1Status !== 0 ||
                                  row?.l1Status == 0 ||
                                  row?.h2Status !== 0)) ||
                              // H2 rules → blocked only if already acted
                              (permissions.h2 &&
                                (row?.l1Status == 0 || row?.h2Status !== 0));

                            const reqDisableReject =
                              row?.h2Status === 1 ||
                              row?.redFlagStatus == 1 ||
                              [
                                row?.l1Status,
                                row?.hodStatus,
                                row?.h1Status,
                                row?.h2Status,
                              ].includes(2) ||
                              (permissions.l1 &&
                                (row?.l1Status !== 0 ||
                                  row?.hodStatus !== 0 ||
                                  row?.h1Status !== 0 ||
                                  row?.h2Status !== 0)) ||
                              (permissions.hod &&
                                (row?.hodStatus !== 0 ||
                                  row?.l1Status !== 1 ||
                                  row?.h1Status !== 0 ||
                                  row?.h2Status !== 0)) ||
                              (permissions.h1 &&
                                (row?.h1Status !== 0 ||
                                  row?.l1Status == 0 ||
                                  row?.h2Status !== 0)) ||
                              (permissions.h2 &&
                                (row?.l1Status == 0 || row?.h2Status !== 0));

                            // Determine button disable logic
                            const disableApprove = requirement
                              ? reqDisableApprove
                              : !matched ||
                                status === "Approved" ||
                                status === "Rejected";

                            const disableReject = requirement
                              ? reqDisableReject
                              : !matched ||
                                status === "Approved" ||
                                status === "Rejected";

                            return (
                              <>
                                {actions.approve &&
                                  (requirement
                                    ? permissions.approve &&
                                      (permissions.l1 ||
                                        (permissions.hod &&
                                          row?.projectHodId == _employeeId) ||
                                        permissions.h1 ||
                                        permissions.h2)
                                    : permissions.approve ||
                                      permissions.allAccess) && (
                                    <button
                                      onClick={() => actions.approve(row)}
                                      disabled={disableApprove}
                                      className={`rounded-md px-3 py-1 mr-2 text-white ${
                                        disableApprove
                                          ? "bg-gray-400 cursor-not-allowed"
                                          : "bg-green-600 hover:bg-green-700"
                                      }`}
                                    >
                                      Approve
                                    </button>
                                  )}

                                {actions.reject &&
                                  (requirement
                                    ? permissions.approve &&
                                      (permissions.l1 ||
                                        (permissions.hod &&
                                          row?.projectHodId == _employeeId) ||
                                        permissions.h1 ||
                                        permissions.h2)
                                    : permissions.approve ||
                                      permissions.allAccess) && (
                                    <button
                                      onClick={() => actions.reject(row)}
                                      disabled={disableReject}
                                      className={`rounded-md px-3 py-1 text-white ${
                                        disableReject
                                          ? "bg-gray-400 cursor-not-allowed"
                                          : "bg-red-600 hover:bg-red-700"
                                      }`}
                                    >
                                      Reject
                                    </button>
                                  )}

                               
                                {actions.redFlag &&
                                  permissions.l1 &&
                                  row?.redFlagStatus != 1 &&
                                  row?.l1Status == 0 && (
                                    <button
                                      onClick={() => actions.redFlag(row)}
                                      disabled={disableReject}
                                      className={`rounded-md px-3 py-1 text-white ${
                                        disableReject
                                          ? "bg-gray-400 cursor-not-allowed"
                                          : "bg-red-600 hover:bg-red-700"
                                      }`}
                                    >
                                      Red Flag
                                    </button>
                                  )}
                              </>
                            );
                          })()}

                          {actions.modal &&
                            (permissions.approve || permissions.allAccess) && (
                              <button
                                onClick={() => actions.modal(row)}
                                className="bg-blue-600 text-white rounded-md px-3 py-1 hover:bg-blue-700"
                              >
                                status
                              </button>
                            )}

                          {((actions.pdfDownload && permissions.pdfDownload) ||
                            (actions.copy && permissions.copy) ||
                            (actions.view && permissions.view) ||
                            (actions.download && permissions.pdfDownload)) && (
                            <>
                              <IconButton
                                size="small"
                                onClick={(e) => handleMenuOpen(e, row)}
                                className="text-blue-600 hover:text-blue-800"
                              >
                                <MoreVertIcon fontSize="small" />
                              </IconButton>
                              <Menu
                                anchorEl={menuAnchorEl}
                                open={Boolean(menuAnchorEl && menuRow === row)}
                                onClose={handleMenuClose}
                              >
                                {(permissions.pdfDownload ||
                                  permissions.allAccess) &&
                                  Array.isArray(actions.pdfDownload) &&
                                  actions.pdfDownload.map((pdf, index) => (
                                    <MenuItem
                                      key={index}
                                      onClick={() => {
                                        handleMenuClose();
                                        pdf.action(menuRow);
                                      }}
                                    >
                                      <PictureAsPdfIcon
                                        fontSize="small"
                                        className="text-blue-600 hover:text-blue-800 mr-2"
                                      />
                                      {pdf.label || "Print"}
                                    </MenuItem>
                                  ))}
                                {actions.copy &&
                                  (permissions.copy ||
                                    permissions.allAccess) && (
                                    <MenuItem
                                      onClick={() => {
                                        handleMenuClose();
                                        actions.copy(menuRow);
                                      }}
                                    >
                                      <ContentCopyIcon
                                        fontSize="small"
                                        className="text-blue-600 hover:text-blue-800 mr-2"
                                      />
                                      Copy
                                    </MenuItem>
                                  )}
                                {actions.download &&
                                  (permissions.pdfDownload ||
                                    permissions.allAccess) && (
                                    <MenuItem
                                      onClick={() => {
                                        handleMenuClose();
                                        actions.download(menuRow);
                                      }}
                                    >
                                      <DownloadIcon
                                        fontSize="small"
                                        className="text-blue-600 hover:text-blue-800 mr-2"
                                      />
                                      Download
                                    </MenuItem>
                                  )}
                                {actions.view &&
                                  (permissions.view ||
                                    permissions.allAccess) && (
                                    <MenuItem
                                      onClick={() => {
                                        handleMenuClose();
                                        actions.view(menuRow);
                                      }}
                                    >
                                      <VisibilityIcon
                                        fontSize="small"
                                        className="text-blue-600 hover:text-blue-800 mr-2"
                                      />
                                      View
                                    </MenuItem>
                                  )}
                              </Menu>
                            </>
                          )}
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}

             {headerEmployee && (
              <>
                <tr>
                  {headerEmployeeKeys?.map((key, j) => (
                    <th
                      key={`emp-${j}`}
                      className="px-4 py-3 whitespace-nowrap capitalize text-center"
                    >
                      {paginatedData?.[0]?.[key] ?? ""}
                    </th>
                  ))}
                </tr>

                {requirement && (
                  <tr>
                    {["Accounts", "HOD", "Management", "Management", "", ""].map((label, i) => (
                      <th
                        key={`static-${i}`}
                        className="px-4 py-3 whitespace-nowrap capitalize text-center"
                      >
                        {label}
                      </th>
                    ))}
                  </tr>
                )}
              </>
      )}

              {paginatedData.length === 0 && (
                <tr>
                  <td
                    colSpan={headers.length + (showCheckbox ? 2 : 1)}
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between gap-2 px-2 py-2 bg-blue-50 text-xs sm:text-sm border-t overflow-x-auto whitespace-nowrap">
          <div className="flex items-center gap-1">
            <span>Rows Per Page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-1 py-0.5 text-xs sm:text-sm"
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option === -1 ? "All" : option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-1">
            <span className="text-gray-600 hidden sm:inline">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                    (currentPage + 1) * rowsPerPage,
                    totalRows,
                  )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-0.5 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListView;
